import { Injectable, Injector } from '@angular/core';
import { DatasourceTableGitFactoryService } from '@y42/datasource';
import { SqlModelingTableGitService } from './sql-modeling-table-git.service';

@Injectable({ providedIn: 'root' })
export class SqlModelingTableGitFactoryService extends DatasourceTableGitFactoryService<SqlModelingTableGitService> {
  constructor(injector: Injector) {
    super({
      injector,
      gitService: SqlModelingTableGitService,
    });
  }
}
